import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { GetCareLayout } from 'components/get-care/get-care-layout.component';

const GetCareLandingPage: React.FC = () => {
  const { formatMessage } = useIntl();

  useDocumentTitle(formatMessage({ id: 'STR_GET_CARE' }));
  usePageViewAnalytics({ screen_name: 'Get Care' });

  return (
    <MainPageContainer
      padding="none"
      paddingX={{ _: 'oneAndHalf', phone: 'two' }}
      paddingBottom={{ _: 'oneAndHalf', phone: 'two' }}
      id="get-care-page"
    >
      <GetCareLayout />
    </MainPageContainer>
  );
};

export default GetCareLandingPage;
